import { gql, useMutation } from '@apollo/client';

import { GET_JOB_BY_ID } from 'src/hooks/jobs/get-job-by-id.hook';
import { GET_PAGINATED_WORKING_CONDITIONS } from 'src/hooks/working-conditions/get-paginated-working-conditions.hook';

export const MAKE_WORKING_CONDITIONS_INACTIVE = gql`
  mutation makeMemberWorkingConditionsInactive($memberId: ObjectId!) {
    makeMemberWorkingConditionsInactive(memberId: $memberId)
  }
`;

export const useMakeMemberWorkingConditionsInactive = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  const [mutation] = useMutation(MAKE_WORKING_CONDITIONS_INACTIVE, {
    onCompleted: data => {
      if (data) onSuccess();
    },
    refetchQueries: [GET_PAGINATED_WORKING_CONDITIONS, GET_JOB_BY_ID],
  });

  return mutation;
};
